import "@fontsource/roboto/400.css";
import "@fontsource/roboto/400-italic.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/900.css";
import "@fontsource/roboto/900-italic.css";
import "@fontsource/roboto-mono/500.css";
import "@fortawesome/fontawesome-svg-core/styles.css";
import "./src/layering.css";
import "@sys42/ui/base.css";
import "@sys42/ui/default-custom-properties.css";
import "./src/global.css";

import React from "react";

import { AuthProvider } from "./src/context/AuthContext";

export const wrapRootElement = ({ element }) => {
  return <AuthProvider>{element}</AuthProvider>;
};
import { config } from "@fortawesome/fontawesome-svg-core";

//github.com/FortAwesome/react-fontawesome/issues/234
config.autoAddCss = false;
